"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSidebarAlias = void 0;
var getSidebarAlias = function (globals) {
    var colors = globals.colors, fonts = globals.fonts;
    return {
        header: {
            backgroundColor: colors.primary.black,
            strokeColor: colors.primary.white,
        },
        backgroundColor: colors.primary.white,
        strokeColor: colors.primary.black,
        userEmailColor: colors.grays[600],
        item: {
            activeBackgroundColor: colors.primary.grays[400],
            hover: {
                backgroundColor: colors.primary.grays[200],
                borderColor: colors.primary.white,
            },
            disabledStrokeColor: colors.primary.grays[200],
            activeIndicatorBorderRadius: 4,
        },
        separatorColor: {
            regular: colors.primary.grays[400],
            dark: colors.primary.grays[800],
        },
        fonts: fonts.secondary,
    };
};
exports.getSidebarAlias = getSidebarAlias;
